export default function PagesIcon({ fill, ...props }) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.025 3.82613L9.43932 0.199467C9.31831 0.0770667 9.15247 0 8.96422 0H3.58569C2.72064 0 2.01695 0.711733 2.01695 1.58667V2.04H1.56874C0.703691 2.04 0 2.75173 0 3.62667V15.4133C0 16.2883 0.703691 17 1.56874 17H9.63653C10.5016 17 11.2053 16.2883 11.2053 15.4133V14.96H11.6535C12.5185 14.96 13.2222 14.2483 13.2222 13.3733V4.30667C13.2222 4.11627 13.146 3.94853 13.025 3.82613ZM9.63653 2.32107L10.9274 3.62667H9.86064C9.73514 3.62667 9.63653 3.52693 9.63653 3.4V2.32107ZM9.86064 15.4133C9.86064 15.5357 9.75755 15.64 9.63653 15.64H1.56874C1.44772 15.64 1.34463 15.5357 1.34463 15.4133V3.62667C1.34463 3.50427 1.44772 3.4 1.56874 3.4H2.01695V13.3733C2.01695 14.2483 2.72064 14.96 3.58569 14.96H9.86064V15.4133ZM11.8776 13.3733C11.8776 13.5003 11.779 13.6 11.6535 13.6H3.58569C3.46019 13.6 3.36158 13.5003 3.36158 13.3733V1.58667C3.36158 1.45973 3.46019 1.36 3.58569 1.36H8.2919V3.4C8.2919 4.27493 8.99559 4.98667 9.86064 4.98667H11.8776V13.3733Z"
        fill={fill ?? "white"}
      />
    </svg>
  );
}
